import React from 'react';
import { PostGroup } from '../../services/postService';
import PostGroupCard from './PostGroupCard';

interface PostListProps {
  postGroups: PostGroup[];
  onDeleteSuccess: () => void;
  viewMode?: 'grid' | 'list';
  selectedPosts?: Set<string>;
  onPostSelect?: (postId: string) => void;
}

const PostList: React.FC<PostListProps> = ({ 
  postGroups, 
  onDeleteSuccess, 
  viewMode = 'grid',
  selectedPosts,
  onPostSelect
}) => {
  const gridClasses = viewMode === 'grid' 
    ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-6"
    : "flex flex-col space-y-4";

  return (
    <div className={gridClasses}>
      {postGroups.map(postGroup => (
        <PostGroupCard 
          key={postGroup.id} 
          postGroup={postGroup} 
          onDeleteSuccess={onDeleteSuccess}
          viewMode={viewMode}
          isSelected={selectedPosts?.has(postGroup.id) || false}
          onSelect={onPostSelect}
        />
      ))}
    </div>
  );
};

export default PostList;